import { css } from '@/styled-system/css';

export const toastBodyStyles = css.raw({
  color: 'inherit',
  textStyle: 'body',
});
